// extracted by mini-css-extract-plugin
module.exports = {"create":"search_create__2ZVOU","otherFilters":"search_otherFilters__edKjm","selection":"search_selection__jubIP","action":"search_action__1_rZJ","title":"search_title__5rLc7"};